import { Box, Button, Input, Typography } from "@mui/material";
import { useRef, useState } from "react";
import { useDevice } from "./DeviceProvider";

export default function Devices() {
    const { connected, log, connect, disconnect, send, onReceive } = useDevice();

    // const [log, setLog] = useState<string[]>([]);
    // const [connected, setConnected] = useState(false);
    const [chessboardIp, setChessboardIp] = useState<string>("");
    const socketRef = useRef<WebSocket | null>(null);

    // const logMessage = (msg: string) => {
    //     setLog((prev) => [`[${new Date().toLocaleTimeString()}] ${msg}`, ...prev]);
    // };

    const connectDevice = () => {
        if (!chessboardIp) {
            return;
        }
        connect(`ws://${chessboardIp}:81`);
    }

    //     const ws = new WebSocket(`ws://${chessboardIp}:81`);
    //     socketRef.current = ws;

    //     ws.onopen = () => {
    //         setConnected(true);
    //         logMessage("Connected to ESP32 WebSocket server");
    //     };

    //     ws.onclose = () => {
    //         setConnected(false);
    //         logMessage("Disconnected from ESP32");
    //     };

    //     ws.onerror = (err) => {
    //         logMessage(`WebSocket error: ${JSON.stringify(err)}`);
    //     };

    //     ws.onmessage = (event) => {
    //         logMessage(`Received: ${event.data}`);
    //     };

    //     return () => {
    //         ws.close();
    //     };
    // };

    const sendMessage = (msg: string) => {
        if (socketRef.current && connected) {
            socketRef.current.send(msg);
            send(`Sent: ${msg}`);
        } else {
            send("WebSocket not connected");
        }
    };

    return (
        <Box style={{ padding: "1rem", fontFamily: "monospace" }}>
            <Typography variant="h4">ESP32 Chess WebSocket Client</Typography>
            <Input
                placeholder="Enter Chess Board IP"
                value={chessboardIp}
                onChange={(v) => setChessboardIp(v.target.value)}
            />
            <Button
                onClick={connectDevice}
            >
                Connect
            </Button>
            <Typography>
                Status: {connected ? "🟢 Connected" : "🔴 Disconnected"}
            </Typography>

            <Button
                onClick={() =>
                    sendMessage(
                        "FEN:rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
                    )
                }
            >
                Send FEN
            </Button>
            <Button
                onClick={() => sendMessage("MOVE:e2e4")}
                style={{ marginLeft: "1rem" }}
            >
                Send Move
            </Button>

            <Box
                style={{
                    marginTop: "1rem",
                    maxHeight: "300px",
                    overflowY: "auto",
                    background: "#111",
                    color: "#0f0",
                    padding: "1rem",
                }}
            >
                {log.map((entry, idx) => (
                    <Box key={idx}>{entry}</Box>
                ))}
            </Box>
        </Box>
    );
}
